<template>
  <ChannelStandardListPage
    detailRouteName="RCSDetailPage"
    channelId="rcs"
    page-title="RCS Channels"
    textNodata="No RCS Chanels Configured Yet"
  />
</template>
<script>
import ChannelStandardListPage from '@/core/components/ChannelStandardListPage.vue'
export default {
  components: {
    ChannelStandardListPage
  },
  setup() {}
}
</script>
